import Axios from 'axios'

/**
 * AXIOS
 */
export default {
  /**
   * 作成
   *
   * @param baseUrl ベースURL
   * @param isLongTimeout 長いタイムアウトかどうか
   * @returns AXIOSインスタンス
   */
  create (baseUrl, isLongTimeout) {
    let timeout
    if (isLongTimeout) {
      timeout = process.env.VUE_APP_API_TIMEOUT_LONG
    } else {
      timeout = process.env.VUE_APP_API_TIMEOUT
    }

    return Axios.create({
      baseURL: baseUrl,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      transformRequest: [data => JSON.stringify(data)],
      responseType: 'json',
      withCredentials: true,
      timeout
    })
  },

  /**
   * ダウンロード
   *
   * @param baseUrl ベースURL
   * @returns AXIOSインスタンス
   */
  download (filePath, fileName) {
    Axios({
      url: `${process.env.VUE_APP_WEB_URL}/${filePath}`,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    })
  }
}
